import { render, staticRenderFns } from "./WidgetLastConstructionSites.vue?vue&type=template&id=e304df82&"
import script from "./WidgetLastConstructionSites.vue?vue&type=script&lang=js&"
export * from "./WidgetLastConstructionSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports